import {Area} from '@lib/store';
import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';

export const SECTION_ID_WORKSPACE_BOOKING_POLICY = 'SECTION_ID_WORKSPACE_BOOKING_POLICY';

export const constructWorkspacePolicyFilter = <
  TEntity extends {workspaceBookingPolicyType: Area['workspaceBookingPolicyType']},
>(
  t: TFunction,
) => {
  const workspacePolicyList = [
    {id: 'AreaBooking', label: t('hereAndNow:AreaBooking')},
    {id: 'DeskBooking', label: t('screen:DeskDetail')},
    {id: 'NonBookable', label: t('hereAndNow:AdHocUseFilter')},
  ];

  return constructFilter({
    sectionId: SECTION_ID_WORKSPACE_BOOKING_POLICY,
    sectionTitle: t('WorkspacePolicy'),
    type: 'or',
    data: workspacePolicyList,
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.workspaceBookingPolicyType === filter.id,
  });
};
